import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب النسبة الموزونة";
const DESCRIPTION =
  "حاسبة النسبة الموزونة الدقيقة: احسب نسبتك المرجحة للقبول الجامعي بناءً على المعدل التراكمي ودرجات القدرات والتحصيلي! أداة معتمدة من قِبل الجهات التعليمية مع شرح لكيفية حساب النسبة الموزونة خطوة بخطوة.";
const KEYWORDS = "حساب, النسبة الموزونة, المعدل التراكمي, القدرات, التحصيلي";
const OG_URL =
  "https://do-calculate.com/calculator/ar/weighted-percentage-calculator/";
function WeightedPercentageCalculator() {
  const [secondaryGrade, setSecondaryGrade] = useState();
  const [aptitudeScore, setAptitudeScore] = useState();
  const [achievementScore, setAchievementScore] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      let weightedPercentage = 0;
      if (secondaryGrade && aptitudeScore && achievementScore) {
        weightedPercentage =
          secondaryGrade * 0.3 + aptitudeScore * 0.3 + achievementScore * 0.4;
      } else if (secondaryGrade && aptitudeScore) {
        weightedPercentage = secondaryGrade * 0.6 + aptitudeScore * 0.4;
      }
      setResult(weightedPercentage.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>تقوم هذه الحاسبة بحساب النسبة الموزونة بناءً على:</p>
                <ul>
                  <li>المعدل التراكمي للثانوية العامة</li>
                  <li>درجة القدرات</li>
                  <li>درجة التحصيلي (إن وجدت)</li>
                </ul>
                <p>يتم تطبيق المعادلات التالية لحساب النسبة الموزونة:</p>
                <ul>
                  <li>
                    (المعدل التراكمي للثانوية العامة × 30%) + (درجة القدرات ×
                    30%) + (درجة التحصيلي × 40%)
                  </li>
                  <li>
                    (المعدل التراكمي للثانوية العامة × 50%) + (درجة القدرات ×
                    20%) + (درجة التحصيلي × 30%)
                  </li>
                  <li>
                    (المعدل التراكمي للثانوية العامة × 60%) + (درجة القدرات ×
                    40%)
                  </li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div
                      className="form-group"
                      htmlFor="secondaryGrade"
                    >
                      <label className="form-label ms-2">
                        المعدل التراكمي للثانوية العامة
                      </label>
                      <input
                        id="secondaryGrade"
                        type="number"
                        value={secondaryGrade}
                        onChange={(e) => setSecondaryGrade(e.target.value)}
                        placeholder="أدخل المعدل التراكمي"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div
                      className="form-group"
                      htmlFor="aptitudeScore"
                    >
                      <label className="form-label ms-2">درجة القدرات</label>
                      <input
                        id="aptitudeScore"
                        type="number"
                        value={aptitudeScore}
                        onChange={(e) => setAptitudeScore(e.target.value)}
                        placeholder="أدخل درجة القدرات"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div
                      className="form-group"
                      htmlFor="achievementScore"
                    >
                      <label className="form-label ms-2">
                        درجة التحصيلي (اختياري)
                      </label>
                      <input
                        id="achievementScore"
                        type="number"
                        value={achievementScore}
                        onChange={(e) => setAchievementScore(e.target.value)}
                        placeholder="أدخل درجة التحصيلي"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">تفاصيل النسبة الموزونة</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      طريقة حساب النسبة الموزونة
                    </h2>{" "}
                  </u>
                  <p>
                    النسبة الموزونة تُحسب باستخدام واحدة من المعادلات التالية
                    بناءً على المتطلبات:
                  </p>
                  <ul>
                    <li>
                      (المعدل التراكمي للثانوية العامة × 30%) + (درجة القدرات ×
                      30%) + (درجة التحصيلي × 40%)
                    </li>
                    <li>
                      (المعدل التراكمي للثانوية العامة × 50%) + (درجة القدرات ×
                      20%) + (درجة التحصيلي × 30%)
                    </li>
                    <li>
                      (المعدل التراكمي للثانوية العامة × 60%) + (درجة القدرات ×
                      40%)
                    </li>
                  </ul>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أهمية النسبة الموزونة</h2>{" "}
                  </u>
                  <p>
                    النسبة الموزونة تُعتبر أحد أهم المعايير التي تُستخدم للقبول
                    في الجامعات، وتختلف النسبة الموزونة من جامعة إلى أخرى.
                  </p>
                  <ul>
                    <li>
                      تحديد مدى استعداد الطالب للبرامج الأكاديمية المختلفة.
                    </li>
                    <li>زيادة فرصة القبول في التخصصات المرغوبة.</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أسئلة شائعة (FAQs)</h2>{" "}
                  </u>
                  <p>
                    هنا يمكنك العثور على الإجابات عن الأسئلة الأكثر شيوعاً حول
                    حساب النسبة الموزونة:
                  </p>
                  <ul>
                    <li>ما هو المعدل التراكمي للثانوية العامة؟</li>
                    <li>
                      كيف تؤثر درجات القدرات والتحصيلي على النسبة الموزونة؟
                    </li>
                    <li>ماذا أفعل إذا لم أكن أملك درجة تحصيلي؟</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WeightedPercentageCalculator;
